module.exports = __webpack_public_path__ + "img/bg-mision-2-17.13691f06.jpg";